<div class="rounded-2xl border border-gray-200 bg-white mb-4">
    <div class="px-4 py-5">
        <h3 class="text-base font-medium text-gray-800">{{ (ownerAddress() ? "common.address.titleOwner" : "common.address.titleAnimal") | translate }}</h3>
    </div>
    <div class="border-t border-gray-200 p-4">
        <ul class="divide-y divide-gray-100">
            <li class="flex items-center gap-5 py-2.5">
                <span class="w-1/2 text-sm text-gray-500">{{ "common.address.countryLabel" | translate }}</span>
                <span class="w-1/2 text-sm font-medium text-gray-700">{{ countryName }}</span>
            </li>
            <li class="flex items-center gap-5 py-2.5">
                <span class="w-1/2 text-sm text-gray-500">{{ "common.address.regionLabel" | translate }}</span>
                <span class="w-1/2 text-sm font-medium text-gray-700">{{ regionName }}</span>
            </li>
            <li class="flex items-center gap-5 py-2.5">
                <span class="w-1/2 text-sm text-gray-500">{{ "common.address.settlementLabel" | translate }}</span>
                <span class="w-1/2 text-sm font-medium text-gray-700">{{ settlementName }}</span>
            </li>
            <li class="flex items-center gap-5 py-2.5">
                <span class="w-1/2 text-sm text-gray-500">{{ "common.address.streetFull" | translate }}</span>
                <span class="w-1/2 text-sm font-medium text-gray-700">{{ `${address().zipCode}, ${address().address}` }}</span>
            </li>
        </ul>
    </div>
</div>

